module.exports = __webpack_public_path__ + "img/en-in.94d229d6.svg";